module.exports = __webpack_public_path__ + "static/media/playalong-token.4fa60e0f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/playalong-token.svg
// module id = ./src/assets/images/playalong-token.svg
// module chunks = 6